import { UwContextDescriptor, UwContextKey, UwWireBinding } from './uw-context.model';

const registeredContexts = new Map<UwContextKey, UwContextDescriptor>();

export function registerUwContext<TProdukt>(descriptor: UwContextDescriptor<TProdukt>): void {
  if (registeredContexts.has(descriptor.key)) {
    throw new Error(`UW context "${descriptor.key}" is already registered.`);
  }
  if (descriptor.wire) {
    assertWireFieldNotClaimed(descriptor.key, descriptor.wire, 'submissionField');
    assertWireFieldNotClaimed(descriptor.key, descriptor.wire, 'printField');
  }
  registeredContexts.set(descriptor.key, descriptor as UwContextDescriptor);
}

function assertWireFieldNotClaimed(
  key: UwContextKey,
  wire: UwWireBinding,
  field: keyof UwWireBinding,
): void {
  const value = wire[field];
  const owner = [...registeredContexts.values()].find(
    registered => registered.wire?.[field] === value,
  );
  if (owner) {
    throw new Error(
      `UW context "${key}" cannot register wire.${field} "${value}": already claimed by UW context "${owner.key}".`,
    );
  }
}

export function unregisterUwContext(key: UwContextKey): void {
  registeredContexts.delete(key);
}

export function getUwContext(key: UwContextKey): UwContextDescriptor {
  const descriptor = registeredContexts.get(key);
  if (!descriptor) {
    throw new Error(`UW context "${key}" is not registered.`);
  }
  return descriptor;
}

export function findUwContext(key: UwContextKey): UwContextDescriptor | undefined {
  return registeredContexts.get(key);
}

export function getAllUwContexts(): UwContextDescriptor[] {
  return [...registeredContexts.values()].sort((a, b) => a.ordinal - b.ordinal);
}
